module.exports = {
  
  // pass an image and the new width and height you'd like it to be
  resize: async (image, w, h, quality) => {
    if (image == undefined) return;
    
    return new Promise( (resolve, reject) => {
      
      // define defaults
      if (w == undefined) w = 200;
      if (h == undefined) h = 200;
      
      // load original image
      let img = new Image();
      img.src = image;
      img.onerror = reject;
      img.onload = () => {

        // initialize two canvases
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        let canvasCopy = document.createElement("canvas");
        let copyContext = canvasCopy.getContext("2d");
        
        // determine new ratio based on max size
        let ratio = 1;
        if (img.width > w) {
          ratio = w / img.naturalWidth;
        } else if (img.height > h) {
          ratio = h / img.naturalHeight;
        }
        
        // draw original image in second canvas
        canvasCopy.width = img.width;
        canvasCopy.height = img.height;
        copyContext.drawImage(img, 0, 0);
        
        // copy and resize second canvas to first canvas
        canvas.width = img.width * ratio;
        canvas.height = img.height * ratio;
        ctx.drawImage(canvasCopy, 0, 0, canvasCopy.width, canvasCopy.height, 0, 0, canvas.width, canvas.height);
        
        resolve( canvas.toDataURL("image/jpeg", quality) );
        
      }
      
    });
    
  },
  
  
}